module.exports = __webpack_public_path__ + "img/apple-icon.9b1b3ac0.png";